import { Spinner } from '@/components';
import { lazyImport } from '@/utils';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

const { IntroRoutes } = lazyImport(() => import('@/pages/intro'), 'IntroRoutes');
const { NotFound } = lazyImport(() => import('@/pages/notFound'), 'NotFound');

export function Public() {
  return (
    <Suspense fallback={<Spinner />}>
      <Outlet />
    </Suspense>
  );
}

export const PublicRoutes = [
  {
    path: '',
    element: <Public />,
    children: [
      {
        path: '',
        element: <IntroRoutes />,
      },
    ],
  },
  {
    path: '*',
    element: <Public />,
    children: [
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];
